import { render } from "./MemberSelector.vue?vue&type=template&id=1a5d28fa&scoped=true"
import script from "./MemberSelector.vue?vue&type=script&lang=js"
export * from "./MemberSelector.vue?vue&type=script&lang=js"

import "./MemberSelector.vue?vue&type=style&index=0&id=1a5d28fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5d28fa"]])

export default __exports__